@import url('./variables/variables.css');
@import url('./components/components.css');
@import url('./vendors/vendors.css');
@import url('./base/base.css');

@tailwind base;
@tailwind components;
@tailwind utilities;

.any-select__menu {
  @apply !max-h-[13rem];
}

.any-select__menu-list {
  @apply !max-h-[13rem];
}

.more-filter-container .mantine-Menu-dropdown {
  padding: 0;
}

.more-filter-container .mantine-Accordion-label {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.more-filter .mantine-Accordion-content {
  padding: 0;
  /* padding-bottom: 0.5rem;
  padding-left: 0.75rem; */
}

.custom-filter-container .mantine-Menu-dropdown {
  padding: 0px;
}

.custom-filter-container .mantine-Accordion-label {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.custom-filter-container .mantine-Button-inner {
  width: 100%;
}

.custom-filter-container .mantine-Button-rightIcon {
  margin-left: auto;
  margin-right: -13px;
}

/* Date Picker Apply Button */
._1gf4hjg4 .mantine-ejv7re {
  background: #3892e5 !important;
}

/* Modal Title */
.mantine-Modal-title {
  width: 100%;
}

/* Effective End Date Input Label */
.effective-end-date-picker label {
  width: 100%;
}

/* mantine-Accordion-content */

/* :root {
  --foreground-rgb: 0, 0, 0;
  --background-start-rgb: 214, 219, 220;
  --background-end-rgb: 255, 255, 255;
}

@media (prefers-color-scheme: dark) {
  :root {
    --foreground-rgb: 255, 255, 255;
    --background-start-rgb: 0, 0, 0;
    --background-end-rgb: 0, 0, 0;
  }
}

body {
  color: rgb(var(--foreground-rgb));
  background: linear-gradient(
      to bottom,
      transparent,
      rgb(var(--background-end-rgb))
    )
    rgb(var(--background-start-rgb));
} */

.mantine-DatePicker-yearsListControl,
.mantine-DatePicker-monthsListControl,
.mantine-DatePicker-calendarHeaderLevel {
  font-size: var(--mantine-font-size-md);
}

.mantine-DatePicker-weekday:nth-child(6) {
  color: rgb(var(--ax-color-blue-5));
}

.mantine-DatePicker-weekday:nth-child(7) {
  color: rgb(var(--ax-color-red-5));
}

.mantine-DatePicker-day {
  font-size: var(--mantine-font-size-md);
  color: rgb(var(--ax-color-text-primary));
}

.mantine-DatePicker-day[data-outside="true"] {
  font-size: var(--mantine-font-size-sm);
  color: rgb(var(--ax-color-text-secondary));
}

.mantine-DatePicker-day[data-selected="true"] {
  color: rgb(var(--ax-color-bg-primary));
}